<template>
  <div>
    <wc-page-title title='Credit Card Processing'></wc-page-title>
    <v-container>
      <v-row>
        <v-col cols='12'>
          <wc-data-box
            title='Receipt Batches'
            :titleIcon='toolbarData.icon'
            :titleIconColor='toolbarData.iconColor'
            :loading='isLoading'
            showAdd
            @add='newDeposit(false)'
            @toggleShowArchived='toggleShowArchived'
          >
            <v-data-table
              dense
              :items='deposits'
              :headers='headers'
              :rows-per-page='20'
              @click:row='openDeposit'
            >
              <template v-slot:item.date='{ item }'>
                {{ item.date | shortDate }}
                <v-icon small color='red' v-if='item.is_locked'>mdi-lock</v-icon>
              </template>
              <template v-slot:item.amount='{ item }'>
                {{ item.amount | decMoney }}
              </template>
            </v-data-table>
          </wc-data-box>
        </v-col>
      </v-row>

      <wc-dialog
        :showDialog='showDialog'
        title='New Batch'
        :icon='toolbarData.icon'
        width='350'
        :loading='isSaving'
        :disableButtons='!isFormValid'
        @cancel='showDialog = false'
        saveText='Continue'
        @save='createBatch'
      >
        <v-form v-model='isFormValid' ref='form'>
          <wc-datepicker
            label='Batch date'
            required
            v-model='depositCopy.date'
            :min='this.$store.state.misc.accounting_settings.closed_fiscal_date'
          ></wc-datepicker>
          <v-text-field
            label='Batch Total'
            v-model='depositCopy.amount'
            :rules='[rules.required]'
          ></v-text-field>
        </v-form>
      </wc-dialog>
    </v-container>
  </div>
</template>

<script>
import depositsAPI from '@/api/accounting';
import formRules from '@/mixins/formRules';
import moment from 'moment';
import _ from 'lodash';

export default {
  name: 'all-deposits',
  mixins: [formRules],
  data: () => ({
    isLoading: true,
    isSaving: false,
    isFormValid: false,
    showArchived: false,
    showDialog: false,
    accounts: [],
    deposits: [],
    depositCopy: {
      date: '',
      account: null,
      deposited_by: null,
      is_credit_card: true
    },
    headers: [
      { text: 'Report date', value: 'date' },
      { text: 'Statement Total', value: 'amount', align: 'right' }
    ]
  }),
  computed: {
    toolbarData () {
      return this.$store.state.icons.dataBox.creditCards
    },
    divisions () {
      return _.orderBy(this.$store.state.misc.divisions, 'order')
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      this.isLoading = true;
      this.deposits = await depositsAPI.getCreditCardBatches();
      this.currentDivision = _.cloneDeep(this.divisions[0]);
      this.isLoading = false;
    },
    toggleShowArchived () {
      this.showArchived = !this.showArchived;
    },
    resetDepositCopy () {
      this.depositCopy.date = moment().format('YYYY-MM-DD').toString();
      this.depositCopy.deposited_by = this.$store.state.auth.profile.id;
      this.depositCopy.is_credit_card = false;
    },
    newDeposit () {
      this.resetDepositCopy();
      this.showDialog = true;
      setTimeout(() => {
        this.$refs.form.resetValidation();
      }, 100)
    },
    async createBatch () {
      this.isSaving = true;
      this.depositCopy.is_credit_card = true;
      let tmp = await depositsAPI.createDeposit(this.depositCopy);
      this.openDeposit(tmp);
    },
    openDeposit (row) {
      this.$router.push({ name: 'CreditCardBatch', params: { id: row.id } });
    }
  }
}
</script>
